import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChatAvatar } from '../../models/chat-room.model';

@Component({
  selector: 'y42-chat-avatar',
  templateUrl: './chat-avatar.component.html',
  styleUrls: ['./chat-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatAvatarComponent {
  @Input() avatar: ChatAvatar = { full_name: '', imgSrc: null, isUnknown: true };
}
